const initialState = {
  data: [],
  isLoading: false,
  error: "",
};

export const getAddressByPostCodeSuccess = (state, {payload}) => ({
  ...state,
  data: payload,
  isLoading: false,
});

export const clearState = () => ({...initialState});

export default initialState;
